import { Link } from "react-router-dom";
import { formatINR } from "@/lib/config";
import { isProductSoldOut } from "@/lib/stock";
import WishlistButton from "./WishlistButton";
import Stars from "./Stars";

export default function ProductCard({ product, rating }) {
  const minPrice = Math.min(...product.sizes.map((s) => s.price));
  const soldOut = isProductSoldOut(product);
  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group flex flex-col bg-cream border border-line hover:border-forest transition-all duration-300 hover:-translate-y-1"
    >
      <div className="relative overflow-hidden aspect-[4/5] bg-cream-200">
        <img
          src={product.image}
          alt={product.name}
          className={`w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04] ${soldOut ? "opacity-60 grayscale-[35%]" : ""}`}
          loading="lazy"
        />
        <span className="absolute top-2.5 left-2.5 md:top-4 md:left-4 bg-cream/90 backdrop-blur text-ink text-[9px] md:text-[10px] uppercase tracking-widest px-2 py-0.5 md:py-1 font-sans rounded-sm">
          {product.category}
        </span>
        {soldOut && (
          <div
            className="absolute inset-x-0 top-1/2 -translate-y-1/2 bg-[#2f3e2d] text-cream text-center text-[11px] md:text-sm uppercase tracking-[0.35em] py-2 md:py-2.5 font-sans shadow-lg"
            data-testid={`sold-out-banner-${product.slug}`}
          >
            Sold out
          </div>
        )}
        <div className="absolute top-2 right-2 md:top-3 md:right-3">
          <WishlistButton slug={product.slug} className="w-8 h-8 md:w-9 md:h-9" size={14} />
        </div>
      </div>
      <div className="px-3.5 py-4 md:px-6 md:py-5 flex flex-col flex-1">
        <h3 className="font-serif text-lg md:text-2xl text-forest leading-tight line-clamp-2">{product.name}</h3>
        {rating && rating.count > 0 && (
          <div className="mt-1.5">
            <Stars value={rating.average} count={rating.count} size={12} />
          </div>
        )}
        <p className="text-[13px] md:text-sm text-ink-muted mt-1.5 md:mt-2 line-clamp-2 font-light hidden sm:block">{product.short_description}</p>
        <div className="mt-auto pt-3 md:pt-5 flex items-baseline justify-between">
          <span className="text-[10px] md:text-xs uppercase tracking-widest text-sage">
            {soldOut ? "Restocking soon" : "From"}
          </span>
          <span className={`font-serif text-lg md:text-xl ${soldOut ? "text-ink-muted line-through" : "text-terra"}`}>{formatINR(minPrice)}</span>
        </div>
      </div>
    </Link>
  );
}
